import { mapEdgesToNodes } from "../../../base/utils";
import { Note, Page } from "../../../helbest";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { useMyOrdersQuery } from "../../../saleor/api";
import { orderListTransformer } from "../../../services/objectTransformer/orders";
import Item from "./Item/Item";
import { useTranslation } from "react-i18next";
import Loading from "../../components/Loading/Loading";

const MyOrdersContent = () => {
  const { data, loading } = useMyOrdersQuery({
    fetchPolicy:"cache-and-network",
    onError: (err) => {
      Note.error(err.message);
    },
  });

  const orders =
    mapEdgesToNodes(data?.me?.orders?.edges, orderListTransformer) || [];

  return (
    <div
      className="w-full flex flex-column justify-start items-center"
      style={{ overflowX: "visible", paddingBlock: "8px" }}
    >
      {!loading &&
        orders.map((node) => {
          return <Item key={node.id} {...node} />;
        })}
      {loading && (
        <div className="text-center mt-2">
          <Loading />
        </div>
      )}
    </div>
  );
};

const MyOrders = () => {
  const { t } = useTranslation();

  return (
    <Page
      className="page-profile"
      back={true}
      address="/"
      customHeader={<HeaderBack title={t("profile.my.orders")}  url="/"/>}
      headerFix
      logo
    >
      <MyOrdersContent />
    </Page>
  );
};

export default MyOrders;
